import { render, staticRenderFns } from "./UploaderView.vue?vue&type=template&id=40ab1cfd&scoped=true"
import script from "./UploaderView.vue?vue&type=script&lang=js"
export * from "./UploaderView.vue?vue&type=script&lang=js"
import style0 from "./UploaderView.vue?vue&type=style&index=0&id=40ab1cfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ab1cfd",
  null
  
)

export default component.exports